<template>
	<LinkButton v-if="portalLink" variant="web-all-black" size="xs" @click="openPortalBackend()">
		{{ t('portalBackend', { storeName: humanReadableStoreName }) }}
	</LinkButton>

	<span v-else>{{ t('portalBackend', { storeName: humanReadableStoreName }) }}</span>
</template>

<script setup lang="ts">
import { type StoreName } from '@bluebrick/discounts-service-module'
import { LinkButton, useTranslation } from '@bluebrick/saas-ui'
import { getPortalLink, openLink, StoreToHumanNameMap } from '@/common/utils'
import { useTelemetry } from '@/features/telemetry/useTelemetry'

const { t } = useTranslation()
const { trackEvent } = useTelemetry()

const props = defineProps<{
	storeName?: StoreName
}>()

const portalLink = getPortalLink(props.storeName)

const humanReadableStoreName = props.storeName && StoreToHumanNameMap.get(props.storeName)

function openPortalBackend() {
	if (!portalLink) {
		return
	}

	trackEvent('user', 'Opened portal backend', { store: props.storeName })

	openLink(portalLink)
}
</script>
